// tslint:disable
export enum MedicalBiGender {
    Male = 'm',
    Female = 'f',
    Unknown = 'u',
}